<template>
  <div v-if="!isKioskModeEnabled" class="pdp-add-to-cart">
    <div v-if="isRetailerOnly || !options.eCommAvailable">
      <div v-if="isRetailerOnly" class="alert negative" v-html="bp('inStoreOnly')" />
      <trek-link
        button
        primary
        block
        icon="pin_drop"
        :href="withContextPath('/store-finder/')"
        data-ga-event="find-a-store-cta"
        data-ga-category="Find a Store CTA"
        data-ga-action="Item Not Available for Purchase"
      >
        <span v-html="bp('retailerButtonCaption')" />
      </trek-link>
    </div>
    <div v-else-if="isAddToCartVisible" class="mb-1">
      <pdl-callout v-if="stockMessage.label" qaid="stock-status-message" :kind="stockStatusCalloutType">
        <template #content>
          <span v-html="stockMessage.label" />
        </template>
      </pdl-callout>

      <trek-button
        id="addToCartButton"
        primary
        block
        icon="shopping_cart"
        :disabled="!isAddToCartEnabled"
        type="submit"
        @click.prevent="addToCart"
      >
        <span id="add-button" v-html="addToCartButtonCaption" />
      </trek-button>
      <pdp-add-to-cart-status :message="message" :base-properties="baseProperties" />
    </div>
    <pdp-replacement
      v-if="product.isArchived && variantCode"
      :replacement-product="replacementProduct"
      :base-properties="baseProperties"
    />
  </div>
</template>
<script>
import PdpAddToCartStatus from '@/components/containers/pdp/PdpAddToCartStatus';
import {Url} from '@/utils/url';
import get from 'lodash/get';
import PdpReplacement from '@/components/containers/pdp/PdpReplacement';
import {isInStockByCode, isBuildToOrderInStockByCode} from '@/components/containers/pdp/utils/retailers-helper';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';

export default {
  name: 'PdpAddToCart',
  components: {PdpReplacement, PdpAddToCartStatus, TrekButton, TrekLink},
  props: {
    addToCartButtonCaption: {
      type: String,
      default: '',
    },
    variantCode: {
      type: String,
      default: '',
    },
    isAddingToCart: {
      type: Boolean,
      default: false,
    },
    stockData: {
      type: Object,
      default: () => ({}),
    },
    stockMessage: {
      type: Object,
      default: () => ({}),
    },
    product: {
      type: Object,
      required: true,
    },
    isPurchasable: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      quantity: 1,
      stockStatusCalloutTypeMap: {
        EnumGlobalStockStatus1: 'success',
        EnumGlobalStockStatus3: 'warning',
        EnumGlobalStockStatus4: 'error',
        EnumGlobalStockStatus5: 'default',
        EnumGlobalStockStatus6: 'warning',
        EnumGlobalStockStatus7: 'warning',
        EnumGlobalStockStatus8: 'default',
        EnumGlobalStockStatus9: 'success',
      },
    };
  },
  computed: {
    isKioskModeEnabled() {
      return this.options.kioskModeEnabledOnSite;
    },

    currentVariant() {
      return this.product.variants?.find((variant) => variant.code === this.variantCode);
    },

    isAddToCartVisible() {
      return !this.product.isArchived;
    },

    isAddToCartEnabled() {
      return (
        this.isPurchasable &&
        !this.isAddingToCart &&
        (isInStockByCode(this.currentVariant?.globalStockStatus) ||
          isBuildToOrderInStockByCode(this.currentVariant?.globalStockStatus) ||
          isInStockByCode(this.currentVariant?.globalStockStatus) ||
          isBuildToOrderInStockByCode(this.currentVariant?.globalStockStatus))
      );
    },

    replacementProduct() {
      if (!this.variantCode) {
        return null;
      }

      return get(
        this.product.variants.find((variant) => variant.code === this.variantCode),
        'replacementProduct'
      );
    },

    isRetailerOnly() {
      return this.product.retailerOnly || this.isVariantRetailerOnly;
    },

    isVariantRetailerOnly() {
      if (!this.variantCode) {
        return null;
      }

      return this.currentVariant.retailerOnly;
    },
    stockStatusCalloutType() {
      return this.stockStatusCalloutTypeMap[this.stockMessage.code];
    }
  },

  methods: {
    withContextPath: (url) => Url.withContextPath(url),
    addToCart() {
      this.$emit('add-to-cart', this.quantity);
    },
  },
};
</script>
